let audio = null;

export function initBootAudio(src) {
    if (!audio) {
        audio = new Audio(src);
        audio.volume = 0.6;
        audio.preload = 'auto';

        
        audio.play()
            .then(() => {
                audio.pause();
                audio.currentTime = 0;
            })
            .catch(() => {});
    }
}

export function playBootAudio() {
    if (audio) {
        audio.currentTime = 0;
        audio.play().catch(() => {});
    }
}
